export const truncateEmail = (email: string, visibleChars = 10) => {
  const atIndex = email.indexOf('@');
  const username = email.slice(0, atIndex);
  const domain = email.slice(atIndex);

  const minLengthToTruncate = visibleChars * 2;

  if (username.length > minLengthToTruncate) {
    const start = username.slice(0, visibleChars);
    const end = username.slice(-visibleChars);
    return { truncatedEmail: `${start}...${end}${domain}`, showTooltip: true };
  }

  return { truncatedEmail: email, showTooltip: false };
};
